import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

const SUPPORTED = ["en", "fr"] as const;

// Priority: ?language= URL param → localStorage → default 'fr'
const urlLang = new URLSearchParams(window.location.search).get("language");
const storedLang = localStorage.getItem("language");
const initialLang: string =
  (SUPPORTED as readonly string[]).includes(urlLang ?? "")
    ? urlLang!
    : (SUPPORTED as readonly string[]).includes(storedLang ?? "")
      ? storedLang!
      : "fr";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      fr: {
        translation: fr,
      },
    },
    lng: initialLang,
    fallbackLng: "fr",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
